/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { injectIntl, intlShape } from 'react-intl';
import { setting } from 'loraactions/tdm';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';
import styles from '../styles.scss';

const kInitialState = {
  status: '',
  errorMsg: typeof FileReader === 'undefined' ? 'UNSUPPORT_FILE_READER' : '',
  content: '',
  fileName: '',
};

const propTypes = {
  intl: intlShape.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  getTypesJSON: PropTypes.func.isRequired,
  typesJSON: PropTypes.object.isRequired,
};

class Upload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...kInitialState,
      show: props.show,
    };
    this.typesJSON = props.typesJSON;
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.upload');
    this.onHide = this.onHide.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
  }

  componentWillReceiveProps({ show, typesJSON }) {
    if (show !== this.props.show) {
      this.setState({ show });
    }
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      this.typesJSON = typesJSON;
    }
  }

  onChangeFile(e) {
    const file = e.target.files[0];
    const reg = /^\S+(.json)$/g;
    if (!reg.test(file.name)) {
      this.setState({ errorMsg: 'FE_JSON_ONLY' });
      return;
    }
    this.setState({ errorMsg: '', fileName: file.name, status: '' });

    const reader = new FileReader();
    reader.onload = () => {
      let result = reader.result;
      result = result.replace(/[\r\n\s]/g, '');
      try {
        const obj = JSON.parse(result);
        if (!obj.networktypes || !obj.networktypes.length) {
          this.setState({ errorMsg: 'REQUIRED_NODETYPES' });
        } else if (!obj.nodetypes || !obj.nodetypes.length) {
          this.setState({ errorMsg: 'REQUIRED_NETWORK' });
        } else {
          this.setState({ content: result }, () => {
          });
        }
      } catch (err) {
        // err
        this.setState({ errorMsg: 'FE_INVALID_JSON' });
      }
    };
    reader.onerror = () => {
      this.setState({ errorMsg: 'FILE_READER_ERROR' });
    };

    reader.readAsText(file);
  }

  onHide() {
    this.props.onHide();
    this.setState({ ...kInitialState });
  }

  uploadFile() {
    const { content } = this.state;
    if (!content) return;

    this.setState({ status: 'pending' });
    const method = this.typesJSON.data ? 'PUT' : 'POST';
    const endpoint = this.typesJSON.data ? '/orgdocs/types' : '/orgdocs';

    callAPI({
      method,
      endpoint,
      body: { name: 'types', content },
    }).then(() => {
      this.setState({ status: 'success', content: '' });
      this.props.getTypesJSON();
      _.delay(() => {
        this.onHide();
      }, 1000);
    }).catch(() => {
      this.setState({ status: 'failure', content: '' });
    });
  }

  render() {
    const {
      show,
      status,
      content,
      fileName,
      errorMsg,
    } = this.state;

    return (
      <Modal
        bsClass="aisz-modal-light"
        backdrop="static"
        show={show}
        onHide={this.onHide}
      >
        <Modal.Header closeButton>
          {this.intlMsg.msg('header')}
        </Modal.Header>
        <Modal.Body>
          <div>
            <Button
              bsStyle="aisz-primary"
              onClick={() => { $('#file').trigger('click'); }}
            >
              {this.intlMsg.msg('btn')}
              <input id="file" type="file" onChange={this.onChangeFile} style={{ display: 'none' }} />
            </Button>
            <span className={styles.fileName}>{fileName}</span>
          </div>
          {errorMsg &&
          <div className={styles.waring}>
            <span className={styles.error}>
              <i className="fa fa-exclamation-triangle" />&nbsp;
              {this.intlMsg.msg(errorMsg)}
            </span>
          </div>
          }
        </Modal.Body>
        <Modal.Footer>
          {status === 'success' &&
            <span className={styles.uploadSuccess}>
              <i className="fa fa-check" />&nbsp;
              {this.intlMsg.msg('success')}
            </span>
          }
          {status === 'failure' &&
            <span className={styles.uploadFail}>
              <i className="fa fa-times" />&nbsp;
              {this.intlMsg.msg('failure')}
            </span>
          }
          <Button
            bsStyle="aisz-default"
            onClick={this.onHide}
            className={styles.white}
          >
            {this.intlMsg.msg('cancel')}
          </Button>
          <Button
            bsStyle="aisz-success"
            onClick={() => this.uploadFile()}
            disabled={status === 'pending' || !content}
          >
            {status === 'pending' && <i className="fa fa-spin fa-spinner m-r-s" />}
            {this.intlMsg.msg('confirm')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

Upload.propTypes = propTypes;

const mapStateToProps = state => ({
  typesJSON: state.tdm.setting,
});

const mapDispatchToProps = {
  getTypesJSON: setting,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Upload));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Network/Upload.jsx